import React, { useEffect, useState, useContext, useRef } from 'react'
import { useParams, Link } from 'react-router-dom'
import { Button } from 'primereact/button'
import { Layout } from '../../components/Layout'
import { Context } from '../../Context'
import { GLOBALS } from '../../utils/Globals'
import { DatalistLaboratories } from '../../components/DatalistLaboratories'
import { LaboratoryService } from '../../services/Laboratory'
import { CoursesService } from '../../services/Courses'
import { Message } from 'primereact/message'
import './styles.scss'

export const Course = () => {
  const { isAuth: token, userLogged } = useContext(Context)
  const { id: CourseId } = useParams()
  const [isLoading, setIsLoading] = useState(true)
  const [course, setCourse] = useState(null)
  const [error, setError] = useState(null)
  const dt = useRef(null)

  useEffect(() => {
    const fetchCourseData = async () => {
      setIsLoading(true)
      try {
        const courseData = await CoursesService.getById(CourseId, token)
        setCourse(courseData)
      } catch (error) {
        setError(error.message)
      } finally {
        setIsLoading(false)
      }
    }

    if (token) {
      fetchCourseData()
    }
  }, [CourseId, token])

  const columns = [
    {
      field: 'name',
      header: 'Nombre',
      sortable: true,
      filter: true,
      filterPlaceholder: 'Buscar por nombre de curso',
    },
    {
      field: 'description',
      header: 'Descripción',
      sortable: true,
      filter: true,
      filterPlaceholder: 'Buscar por descripcion',
    },
    {
      field: 'status',
      header: 'Estado',
      sortable: true,
      filter: false,
    },
  ]

  const customActionButtons = ({ row }) => {
    if (userLogged.role === 'T') {
      // Si es profesor, mostrar ambos botones
      return (
        <>
          <Link
            to={`${GLOBALS.menu.scheduler.link}/create?laboratory_id=${row.id}`}
            style={{ marginRight: '8px' }}
          >
            <Button
              type="button"
              icon="pi pi-calendar-plus"
              className="p-button-success"
              tooltip="Reservar"
            ></Button>
          </Link>
          <Link to={`${GLOBALS.menu.laboratories.viewlaboratory}/${row.id}`}>
            <Button
              type="button"
              icon="pi pi-chevron-circle-right"
              className="p-button-primary"
              tooltip="Ver"
            ></Button>
          </Link>
        </>
      )
    } else if (userLogged.role === 'U') {
      return (
        <Link to={`${GLOBALS.menu.scheduler.link}/create?laboratory_id=${row.id}`}>
          <Button
            type="button"
            icon="pi pi-calendar-plus"
            className="p-button-success"
            tooltip="Reservar"
          ></Button>
        </Link>
      )
    } else {
      // Si es admin, solo mostrar botón de ver
      return (
        <Link to={`${GLOBALS.menu.laboratories.viewlaboratory}/${row.id}`}>
          <Button
            type="button"
            icon="pi pi-chevron-circle-right"
            className="p-button-primary"
            tooltip="Ver"
          ></Button>
        </Link>
      )
    }
  }

  return (
    <Layout>
      <>
        {isLoading ? (
          <div className="loading-container">
            <i className="pi pi-spin pi-spinner" style={{ fontSize: '4em' }}></i>
          </div>
        ) : error ? (
          <Message severity="error" text={error}></Message>
        ) : (
          <div className="p-grid">
            <div className="p-col-12">
              <div className="card">
                <div className="title-wrap">
                  {/*                 <h1 className="title">
                    {config.icon && <i className={config.icon}></i>}
                    {config.title}
                    <Link to={config.backlink} className="back-link">Volver</Link>
                  </h1> */}
                </div>

                {course && (
                  <DatalistLaboratories
                    ref={dt}
                    menuItem={GLOBALS.menu.laboratories}
                    listItems={() => course.laboratories}
                    bulkDelete={(ids) => LaboratoryService.bulkDelete(ids, token)}
                    columns={columns}
                    customActionButtons={customActionButtons}
                  ></DatalistLaboratories>
                )}
              </div>
            </div>
            <div className="p-col-12"></div>
          </div>
        )}
      </>
    </Layout>
  )
}
